import { AttributesValues } from '../clients/DiscoveryPagesServiceClient';
import { acceptableAttributes } from '../helpers/constants';

export const getAttributeValuesFromSource = (attributesWithValues: AttributesValues, attributeName: string): string[] =>
  attributesWithValues[attributeName]?.sort() ?? [];

export const getAcceptableAttributesFromSource = (attributesWithValues: AttributesValues): string[] =>
  Object.keys(attributesWithValues)
    .filter((attributeName) => acceptableAttributes.includes(attributeName))
    .sort();
